export default __webpack_public_path__ + "static/media/GarcesFruit.db3db168.svg";